/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { ROUTES } from '@kamernet/core/Routing';
import { NavLink } from '@kamernet/core/Routing/NavLink';

import styles from './Content.module.css';

export const ContentCountryGeneric = () => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Rental Properties in the Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Looking for rental properties in the Netherlands? Look no further!
        Kamernet offers a diverse selection of homes for rent across the
        country. The diversity of rental housing in the Netherlands ensures that
        there's something for every price range and level of amenities.`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Finding affordable housing in the Netherlands has never been simpler.
        With our user-friendly platform and advanced search filters, you can
        quickly browse through rental properties across the country. Whether
        you're looking for mid-range rentals, private rental homes, or
        properties in the city centre, Kamernet has got you covered. Our
        comprehensive listings make it easy to find cheap accommodation in the
        Netherlands within your budget.`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Browse the latest rental listings and secure your new rental property
        across the Netherlands today. Whether you're relocating for work, study,
        or a fresh start, Kamernet is here to assist you in finding the perfect
        rental property that meets your requirements and preferences. Don't wait
        any longer, start your search for your new accommodation in the
        Netherlands leading rental property website now.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Useful Links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-almere' },
          Locale.en,
        )}
      >
        Almere Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-nijmegen' },
          Locale.en,
        )}
      >
        Nijmegen Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-hilversum' },
          Locale.en,
        )}
      >
        Hilversum Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-eindhoven' },
          Locale.en,
        )}
      >
        Eindhoven Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-hoofddorp' },
          Locale.en,
        )}
      >
        Hoofddorp Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-zaandam' },
          Locale.en,
        )}
      >
        Zaandam Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-arnhem' },
          Locale.en,
        )}
      >
        Arnhem Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-tilburg' },
          Locale.en,
        )}
      >
        Tilburg Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-enschede' },
          Locale.en,
        )}
      >
        Enschede Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-amersfoort' },
          Locale.en,
        )}
      >
        Amersfoort Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-zeist' },
          Locale.en,
        )}
      >
        Zeist Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-breda' },
          Locale.en,
        )}
      >
        Breda Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-maastricht' },
          Locale.en,
        )}
      >
        Maastricht Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-nieuwegein' },
          Locale.en,
        )}
      >
        Nieuwegein Properties
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'properties-schiedam' },
          Locale.en,
        )}
      >
        Schiedam Properties
      </NavLink.Anchor>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Huurwoningen in Nederland
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Op zoek naar huurwoningen in Nederland? Zoek niet verder! Kamernet biedt
        een divers aanbod aan huizen te huurdoor het hele land. De diversiteit
        aan huurwoningen in Nederland zorgt ervoor dat er voor elk prijsniveau
        en niveau van voorzieningen iets te vinden is.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Een goedkope huurwoningvinden in Nederland was nog nooit zo eenvoudig.
        Met ons gebruiksvriendelijke platform en geavanceerde zoekfilters kun je
        snel door huurwoningen in heel Nederland zoeken. Of je nu op zoek bent
        naar midden huur, particuliere huurwoningen, of woningen in het centrum
        van de stad, Kamernet heeft alles wat je zoekt. Onze uitgebreide aanbod
        maakt het gemakkelijk om goedkopehuurwoningen of tijdelijke te vinden
        die passen bij jouw levensstijl.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Doorzoek het nieuwste aanboden vind vandaag nog jouw nieuwe huurwoning
        door heel Nederland. Of je nu verhuist voor werk, studie, of een frisse
        start, Kamernet staat voor je klaar om je te helpen bij het vinden van
        de perfecte huurwoning die voldoet aan jouw eisen en voorkeuren. Wacht
        niet langer, begin nu met zoeken naar jouw nieuwe thuis op de
        toonaangevende website voor huurwoningen in Nederland.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Handige links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-almere' },
          Locale.nl,
        )}
      >
        Huurwoningen Almere
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-nijmegen' },
          Locale.nl,
        )}
      >
        Huurwoningen Nijmegen
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-hilversum' },
          Locale.nl,
        )}
      >
        Huurwoningen Hilversum
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-eindhoven' },
          Locale.nl,
        )}
      >
        Huurwoningen Eindhoven
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-hoofddorp' },
          Locale.nl,
        )}
      >
        Huurwoningen Hoofddorp
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-zaandam' },
          Locale.nl,
        )}
      >
        Huurwoningen Zaandam
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-arnhem' },
          Locale.nl,
        )}
      >
        Huurwoningen Arnhem
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-tilburg' },
          Locale.nl,
        )}
      >
        Huurwoningen Tilburg
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-enschede' },
          Locale.nl,
        )}
      >
        Huurwoningen Enschede
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-amersfoort' },
          Locale.nl,
        )}
      >
        Huurwoningen Amersfoort
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-zeist' },
          Locale.nl,
        )}
      >
        Huurwoningen Zeist
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-breda' },
          Locale.nl,
        )}
      >
        Huurwoningen Breda
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-maastricht' },
          Locale.nl,
        )}
      >
        Huurwoningen Maastricht
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-nieuwegein' },
          Locale.nl,
        )}
      >
        Huurwoningen Nieuwegein
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingSearchCity.url(
          { typeAndCity: 'huurwoningen-schiedam' },
          Locale.nl,
        )}
      >
        Huurwoningen Schiedam
      </NavLink.Anchor>
    </React.Fragment>
  );
};
